module.exports = __webpack_public_path__ + "img/18.c1519f2c.jpg";